import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getSideBarfilesActions,
  setThePerformFieldAGentGet,
  setThecountBasedRenders,
  setTheoptions,
  SetTheIDs,
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  SetThePerformanceExportSheetDatasActions, ///---Perfomance---exports
  getRoleListActions, /// Role---Filters
  setClientBranchActions, ///--Branch---Slice
  setDropDownRenders,
  setClientBranchSearchAction,
  setTheSillAsssessmentsStatus,
  setTheSillAsssessmentsState,
  setTheSillAsssessmentsRegion,
  setTheSillAsssessmentsZONE,
  setTheSillAsssessmentsAppsideCompleted,
  setTHeSkillAssessmentsMonthanYearsFilter,
  setTHeSkillAssessmentsClient_Filter,
  setTHeSkillAssessmentsDesginationsFilter

} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import "../../../StyleSheet/MainComponent/ManPowerPerfomance.scss";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import _, { values } from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import AttedanceExport from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";
import useDebouncedEffect from 'use-debounced-effect';


const ManPower = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const UserObjectData = useSelector((state) => state.users.UserData);

  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [EditPopupCall, setEditPopup] = useState(false);
  const [EditID, setEditId] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const [createPerform, setcreateperform] = useState(false);
  const [userId, setuserid] = useState();

  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() +1;
  const stateManagemonth =
    state.StateManagementOverallCall.skillassessmentsStatusMonthYear?.month < 10
      ? `0${state.StateManagementOverallCall.skillassessmentsStatusMonthYear?.month}`
      : state.StateManagementOverallCall.skillassessmentsStatusMonthYear?.month;
  const statemanageyear =
    state.StateManagementOverallCall.skillassessmentsStatusMonthYear?.year;
  useEffect(() => {
    if (Data.month == "") {
      setYearMpnth(`${date.getFullYear()}-${months}`);
    } else {
      setYearMpnth(`${statemanageyear}-${stateManagemonth}`);
    }
  }, []);

  const [CLientValue, setClientValue] = useState(
    state.StateManagementOverallCall.SkillassessmentCLient
  );
   const [DesginationVal , setDesginationVal] = useState(
    state.StateManagementOverallCall.Skillassessmentrole
   )
  const [Data, setdata] = useState({
    month:
      state.StateManagementOverallCall.skillassessmentsStatusMonthYear?.month,
    year: state.StateManagementOverallCall.skillassessmentsStatusMonthYear
      ?.year,
  });

  ////---- end of the filters
  const FileterState = {
    status: state.StateManagementOverallCall.SkillAssesments?.value,
  };
  const [selectVal, SetSelectval] = useState(FileterState);
  ////--_FIlter--------------------------
  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    state.StateManagementOverallCall.skillassessmentsRegion,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    state.StateManagementOverallCall.skillassessmentsZone,
  ]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
    zone: state.StateManagementOverallCall.skillassessmentsZone?.value,
    state: state.StateManagementOverallCall.skillassessmentsStatusState?.value,
    region: state.StateManagementOverallCall.skillassessmentsRegion?.value,
  });
  const [multiselect, setMuliselect] = useState([
    state.StateManagementOverallCall.skillassessmentsStatusState,
    // state.ClientBranchIDs.StateName,
  ]);
  const [RoleOpions, setRoleOptions] = useState();
  const [BranchNameList, setBranchnamelIST] = useState();
  const [ListedDatas, setListDatas] = useState({ 
    client_id: state.StateManagementOverallCall.SkillassessmentCLient?.value, 
    role_id: state.StateManagementOverallCall.Skillassessmentrole?.value
   });
  ///----Filter-----------------------

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    RoleSearch: "",
    BranchSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    RoleSearch: "",
    BranchSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///---filter--------------------

  const [completedstatus, setcompletedstus] = useState({
    completed:
      state.StateManagementOverallCall.skillassessmentsdesignation?.value,
  });
  const [AllEmp, setALlEMp] = useState(
    state.StateManagementOverallCall.skillassessmentsdesignation
  );
  const optionsforfilter = [
    {
      label: "ALL",
      value: false,
    },
    {
      label: "COMPLETED",
      value: true,
    },

  ];



  const handlechangescompletd = (e) => {
    setdtPageindex(1);
    setALlEMp(e);
    setcompletedstus({
      completed: e.value,
    });
    dispatch(setTheSillAsssessmentsAppsideCompleted(e));
  };

  useEffect(() => {
    //---Dispatch-----
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      month: Data.month,
      year: Data.year,
      selectVal: selectVal,
      data: data,
      is_complete: completedstatus,
      client_id: ListedDatas.client_id,
      role: ListedDatas.role_id,
    };
    dispatch(setThePerformFieldAGentGet(payload));
  }, [Data, selectVal, data, completedstatus, ListedDatas, dtpageindex]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };


  const handleChange = (e) => {
    const inputValue = e.target.value;
    // setMonthYear(inputValue);
    // setMonthFilter(true);
    setdtPageindex(1);
  
    const months = new Date(inputValue);
    
    // Validate date before proceeding
    if (isNaN(months.getTime())) {
      console.error("Invalid date selected");
      return;
    }
  
    const selectedMonth = String(months.getMonth() + 1).padStart(2, "0"); // Ensures 2-digit format
    const selectedYear = months.getFullYear();
  
    setYearMpnth(`${selectedYear}-${selectedMonth}`);
    // console.log(selectedYear, "weurweydsfsd", selectedMonth);
  
    setdata({
      ...Data,
      month: selectedMonth,
      year: selectedYear,
    });
  
    dispatch(
      setTHeSkillAssessmentsMonthanYearsFilter({
        month: selectedMonth,
        year: selectedYear,
      })
    );

  };
  


  useEffect(() => {
    const payloads = {
      search: SearchedVal.RoleSearch,
      page_size: 10,
      page: 1,
      mode: "all",
      // client: "",
      client:ListedDatas.client_id,
      white_collar: false,
    };
    dispatch(getRoleListActions(payloads));
  }, [SearchedVal.RoleSearch,ListedDatas.client_id]);

  useEffect(() => {
    const Datas = [];

    if (state.rolelists.RoleList != undefined) {
      let objectArray = [];
      state.rolelists.RoleList.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.role.toUpperCase(),
        });
      });

      setRoleOptions(objectArray);
    }
  }, [state.rolelists, SearchedVal.RoleSearch]);

  const handleInputChangeRole = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      RoleSearch: Val,
    });
  };

  const handleInputChangeBranch = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      BranchSearch: Val,
    });
  };

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  ///---------------Branch---APi
  useEffect(() => {
    const payload = {
      search: SearchedVal.BranchSearch,
      page_size: 10,
      page: 1,
      data: data,
    };
    // dispatch(setClientBranchActions(payload)); ///----branch--------
    dispatch(setClientBranchSearchAction(payload));
  }, [SearchedVal.BranchSearch, data]);

  ///--Branche name

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setBranchnamelIST(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, SearchedVal.BranchSearch]);

  useEffect(() => {
    const Datas = [];

    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        region: selectedVal.value,
      });

      dispatch(setTheSillAsssessmentsRegion(selectedVal));

      dispatch(setTheSillAsssessmentsZONE({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...data,
        zone: "",
        region: "",
      });

      dispatch(setTheSillAsssessmentsRegion({ value: "", label: "ALL" }));

      dispatch(setTheSillAsssessmentsZONE({ value: "", label: "ALL" }));
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);

      setData({
        ...data,
        zone: selectedVal.value,
      });
      dispatch(setTheSillAsssessmentsZONE(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheSillAsssessmentsZONE({ value: "", label: "ALL" }));
    }
  };

  const handleSelectChange = (selectedVal) => {
    // console.log(selectedVal, "selectedval");
    setClientValue({ value: "", label: "Select" });
    dispatch(setTheSillAsssessmentsState(selectedVal));
    dispatch(setTheSillAsssessmentsRegion({ value: "", label: "ALL" }));

    dispatch(setTheSillAsssessmentsZONE({ value: "", label: "ALL" }));

    if (selectedVal != null) {
      setMuliselect1([]);
      setMuliselect3([]);

      setMuliselect(selectedVal);
      console.log(selectedVal, "asfad");
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
      setMuliselect([]);

      setMuliselect1([]);
      setMuliselect3([]);
      dispatch(setTheSillAsssessmentsState({ value: "", label: "ALL" }));
      dispatch(setTheSillAsssessmentsRegion({ value: "", label: "ALL" }));

      dispatch(setTheSillAsssessmentsZONE({ value: "", label: "ALL" }));
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
                BranchSearch:SearchDebounance.BranchSearch,
                RoleSearch:SearchDebounance.RoleSearch
            });
        }
    },
    500,
    [SearchDebounance]
);

///-----State----Input Changes
const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,
        

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: 10,
          page: dtpageindex,
          month: Data.month,
          year: Data.year,
          selectVal: selectVal,
          data: data,
          is_complete: completedstatus,
          client_id: ListedDatas.client_id,
          role: ListedDatas.role_id,
        };
        dispatch(setThePerformFieldAGentGet(payload));
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
    debouncedSearch(e);
    setdtPageindex(1);
  }
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const columns = [
//          {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name != undefined ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.email != undefined &&
            row.row.original.user_id.email != null ? (
              <span>{row.row.original.user_id.email}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.user_role != undefined &&
            row.row.original.user_id.user_role.role != undefined ? (
              <span>{row.row.original.user_id.user_role.role}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.client_name &&
            row.row.original.client_name != undefined ? (
              <span>{row.row.original.client_name}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.user_id.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {row.row.original.user_id.created_at != undefined &&
              row.row.original.user_id.created_at != null
                ? `${
                    row.row.original.user_id.created_at.slice(0, 10) +
                    "  " +
                    formattedTime
                  }`
                : "---"}
            </span>
          </>
        );
      },
    },
 {
      Header: "Grade",
      accessor: "",
      Cell: (row) => {
          return (
              <>
                  {row.row.original.is_completed != undefined &&
                      row.row.original.is_completed != null ? (
                      <span>{row.row.original.is_completed == true ?
                          <><span className="statusstyles">{row.row.original.grade}</span></>:
                          <>{"----"}</>
                      }</span>
                  ) : (
                      <span>{"--"}</span>
                  )}
              </>
          );
      },
  },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        if (
          row.row.original.perform_answer != null &&
          row.row.original.perform_answer.status != undefined &&
          row.row.original.perform_answer.status != null
        ) {
          const originalString =
            row.row.original.perform_answer != undefined &&
            row.row.original.perform_answer != null
              ? row.row.original.perform_answer.status
              : "";
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.perform_answer != undefined &&
              row.row.original.perform_answer.status != undefined ? (
                <>
                  {row.row.original.perform_answer.status.toLowerCase() ==
                  "pending" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{capitalizedString}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.perform_answer.status.toLowerCase() ==
                      "decline" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{capitalizedString}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.perform_answer.status.toLowerCase() ==
                          "approved" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{capitalizedString}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        } else if (row.row.original.perform_answer == null) {
          return (
            <>
              <p>{"-----"}</p>
            </>
          );
        }
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  // setEditId(row.row.original.id);
                  // setEditPopup(true);
                  dispatch(SetTheIDs(row.row.original.user_id.id));
                  navigate("/manpowerperform");
                }}
                component="span"
              >
                <span className="OuterActionSpan">

                  <span className="EditImages">
                    <img src={EditImages} />
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },

    {
      Header: "Export",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.id != undefined &&
            row.row.original.user_id.id != null ? (
              <div
                className="SHeet"
                style={{ color: "#234492", cursor: "pointer", display: "flex" }}
                onClick={(e) => {
                  const payload = {
                    user_id: row.row.original.user_id.id,
                  };
                  dispatch(SetThePerformanceExportSheetDatasActions(payload));
                }}
              >

                <span className="AttendanceExportImage">
                  <img src={AttedanceExport} />
                </span>
                <span className="tooltiptext" style={{ fontWeight: "800" }}>
                  Export
                </span>
              </div>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
  ].filter(Boolean)

  const handleClick = (id) => {
    setcreateperform(true);

    setuserid(id.id); ////-------to--create--performs-----first----need---the----user---id---
    //based---------on-the---id---the----inner---data--will---display
    ///---------if---the---create--state---is---true----then-----the---id---will dispatch--and---navigate--
    // dispatch(SetTheIDs(id.id));
    // navigate("/manpowerperform");
    // console.log(id, "id");
  };

  const ClearState = (Counts) => {
    ///dispatch(setTheoptions({ value: "1", label: "ALL" }));
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
      setdtPageindex(1);
      dispatch(setTheSillAsssessmentsStatus({ value: "", label: "All" }));
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    dispatch(setTheSillAsssessmentsStatus(SelectedValues));
    dispatch(setThecountBasedRenders(2));

    setdtPageindex(1);
    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  console.log(ListedDatas ,"1202398ListedDatas");
  
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3> Assessments Request</h3>
          </div>

        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "93",
               

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-3">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);

                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>

          <div className="col-sm-3">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);
                setMuliselect3([]);
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
            isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
              value={multiselect1}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-3">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handleZone(e);
              }}
              options={nameList4}
              value={multiselect3}
           isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>
        </div>
        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-3">
            <label for="validationCustom01" class="form-label">
              Client List
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);
                setDesginationVal({value:"",label:"ALL"})
                setListDatas({
                  ...ListedDatas,
                  role_id: "",
                });
                dispatch(setTHeSkillAssessmentsDesginationsFilter({value:"",label:"ALL"}))

                if (e != null) {
                  setListDatas({
                    ...ListedDatas,
                    client_id: e.value,
                  });

                  setdtPageindex(1);
                  setClientValue(e);
                  dispatch(setTHeSkillAssessmentsClient_Filter(e))
                } else if (e == null) {
                  setListDatas({
                    ...ListedDatas,
                    client_id: "",
                  });
                  setClientValue({ value: "", label: "Select" });
                  dispatch(setTHeSkillAssessmentsClient_Filter({value: "", label: "ALL"}))

                }
              }}
           isClearable={
  CLientValue
    ? Array.isArray(CLientValue)
      ? CLientValue.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : CLientValue.label === "ALL" || CLientValue.label === "All"
      ? false
      : true
    : true
}              options={BranchNameList}
              onInputChange={handleInputChangeBranch}
              labelledBy="Select"
              value={CLientValue}
            />
          </div>

          <div className="col-sm-3">
            <label for="validationCustom01" class="form-label">
              Designation
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);

                if (e != null) {
                  setListDatas({
                    ...ListedDatas,
                    role_id: e.value,
                  });
                  setDesginationVal(e)
                  dispatch(setTHeSkillAssessmentsDesginationsFilter(e))

                } else if (e == null) {
                  setListDatas({
                    ...ListedDatas,
                    role_id: "",
                  });
                  dispatch(setTHeSkillAssessmentsDesginationsFilter({value:"",label:"ALL"}))
                  setDesginationVal({value:"",label:"ALL"})
                }
              }}
           isClearable={
  DesginationVal
    ? Array.isArray(DesginationVal)
      ? DesginationVal.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : DesginationVal.label === "ALL" || DesginationVal.label === "All"
      ? false
      : true
    : true
}              options={RoleOpions}
              labelledBy="Select"
              onInputChange={handleInputChangeRole}
              value={DesginationVal}
            />
          </div>
          <div className="col-sm-3">
            <div
              className="SHeet"
              style={{
                color: "#F37738",
                display: "flex",
                flexDirection: "row",
                cursor: "pointer",
                height: "100%",
                alignItems: "center",
                paddingLeft: "45px",
              }}
            >
              <button
                align="center"
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  background: "transparent",
                }}
                onClick={(e) => {
                  if (
                    // ListedDatas.role_id != "" ||
                    ListedDatas.client_id != ""
                  ) {
                    Swal.fire({
                      title:
                        `Are you sure, do you want to Export the sheet?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#234492",
                      cancelButtonColor: "#6c757d",
                      confirmButtonText: "Yes, Export  it!",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        const payload = {
                          user_id: "",
                          role_id: ListedDatas.role_id,
                          client_id: ListedDatas.client_id,
                        };
                         console.log(payload ,"payload");
                         
                        dispatch(
                          SetThePerformanceExportSheetDatasActions(payload)
                        );
                      } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.close();
                      }
                    });
                  } else {
                    toast.error(
                      "You cannot export the sheet without selecting a client ",
                      {
                        position: toast.POSITION.TOP_RIGHT,
                      }
                    );
                  }
                }}
              >
                <a class="dnbtn"></a>
              </button>
            </div>
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <div
            style={{
              position: "absolute",
              height: "71px",
              zIndex: "1",
              width: "64%",
              display: "flex",
              //justifyContent: "flex-start",
              justifyContent: "flex-end",
              // paddingRight: "220px",
              alignItems: "flex-start",
              flexDirection: "row",
              right: "335px",
              gap: "20px",
            }}
            className="innnermontfilters"
          >
            {/* 
<div class="col-sm-2 field-div">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Employee Role
                          </label>


                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              HandleEMprole(e);
                            
                            }}
                            value={EMpROleSelected}
                            options={EmpRoles}
                            placeholder="search"
                          />


                        </div> */}

            {/* <div
              className="completedstatues"
              style={{ display: "inline", marginTop: "6px" }}
            >
              <label>App side completed</label>
              <Select
                options={optionsforfilter}
                onChange={handlechangescompletd}
                value={AllEmp}
              />
            </div> */}
            {/* <div style={{ display: "inline", marginTop: "6px" }}>
              <p>Month</p>
              <input
                type="month"
                value={yearAndMonth}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div> */}
          </div>
          <ReactTable
            data={state.PerformFieldAGentGet.performsDataField}
            columns={columns}
            totalItems={state.PerformFieldAGentGet.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.PerformFieldAGentGet.Total_Count}
            MakeCreate={true}
            ViewParts={(e) => {
              handleClick(e);
            }}
            values={state.StateManagementOverallCall.SkillAssesments}
            options={options}
            Filter={true}
            count={count}
            ClearState={ClearState}
            placeHold={"All"}
            ApproveRequestFilter={true}
            //---Month based filter
            MonthFilter={true}
            yearAndMonth={yearAndMonth}
            handleChange={handleChange}
            ///--APp side completed View
            iscompletedLabel="App side completed"

            AppSideView={true}
            AllEmp={AllEmp}
            handlechangescompletd={handlechangescompletd}
            optionsforfilter={optionsforfilter}
          />
        </div>
      </div>
    </>
  );
};

export default ManPower;
